import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import { useNavigate, useParams } from "react-router-dom";
import {
  CheckBox,
  InputBox,
  SubmitButton,
  TextAreaBox,
  UploadBox,
} from "../../components/Input";

const MobileContentForm = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Using useParams hook to get the URL parameters

  const [formData, setFormData] = useState({
    title: "",
    btn_text: "",
    btn_link: "",
    banner_type: "",
    text1: "",
    text2: "",
    text3: "",
    description: "",
    old_file_url: "",
    isactive: 1,
    id: "",
  });

  const [operation, setOperation] = useState("Add");
  const [bannerType, setBannerType] = useState(0); // Default banner type (0)
  const [filePreview, setFilePreview] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      // Fetch existing data for the edit operation
      setOperation("Edit");
      axios
        .get(`/website/contents/${id}`)
        .then((response) => {
          const data = response.data;
          setFormData({
            ...formData,
            title: data.title,
            btn_text: data.btn_text,
            btn_link: data.btn_link,
            banner_type: data.banner_type,
            text1: data.text1,
            text2: data.text2,
            text3: data.text3,
            description: data.description,
            old_file_url: data.file_url,
            isactive: data.isactive,
            id: data.id,
          });
          setFilePreview(data.file_url);
          setBannerType(data.banner_type);
        })
        .catch((err) => {
          console.error("Error fetching data", err);
        });
    }
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFilePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const apiUrl = formData.id
      ? `/website/contents/save/${formData.id}`
      : "/website/contents/save";

    axios
      .post(apiUrl, formData)
      .then((response) => {
        swal("Success!", "Content saved successfully.", "success");
        navigate("/Website/Contents");
      })
      .catch((error) => {
        swal("Error!", "There was an error saving the content.", "error");
        setLoading(false);
      });
  };

  const renderTextFields = () => {
    return (
      <>
        <div className="form-group col-md-6">
          <InputBox
            label="Title"
            fieldname="title"
            placeholder="Enter Title"
            value={formData.title}
            onChange={handleInputChange}
          />
        </div>

        {bannerType !== 2 &&
          bannerType !== 3 &&
          bannerType !== 4 &&
          bannerType !== 6 && (
            <>
              <div className="form-group col-md-6">
                <InputBox
                  label="Button Text"
                  fieldname="btn_text"
                  placeholder="Enter Button Text"
                  value={formData.btn_text}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group col-md-6">
                <InputBox
                  label="Button Link"
                  fieldname="btn_link"
                  placeholder="Enter Button Link"
                  value={formData.btn_link}
                  onChange={handleInputChange}
                />
              </div>
            </>
          )}

        {bannerType === 3 && (
          <div className="form-group col-md-6">
            <InputBox
              label="Link"
              fieldname="btn_link"
              placeholder="Enter Link"
              value={formData.btn_link}
              onChange={handleInputChange}
            />
          </div>
        )}

        {bannerType === 4 && (
          <>
            <div className="form-group col-md-6">
              <InputBox
                label="Button Text"
                fieldname="btn_text"
                placeholder="Enter Button Text"
                value={formData.btn_text}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group col-md-6">
              <InputBox
                label="Small Text"
                fieldname="text1"
                placeholder="Enter Small Text"
                value={formData.text1}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group col-md-6">
              <InputBox
                label="Information Text"
                fieldname="text2"
                placeholder="Enter Information Text"
                value={formData.text2}
                onChange={handleInputChange}
              />
            </div>
          </>
        )}

        {bannerType === 0 && (
          <>
            <div className="form-group col-md-6">
              <InputBox
                label="Text 1"
                fieldname="text1"
                placeholder="Enter Text 1"
                value={formData.text1}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group col-md-6">
              <InputBox
                label="Text 2"
                fieldname="text2"
                placeholder="Enter Text 2"
                value={formData.text2}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group col-md-6">
              <InputBox
                label="Text 3"
                fieldname="text3"
                placeholder="Enter Text 3"
                value={formData.text3}
                onChange={handleInputChange}
              />
            </div>
          </>
        )}

        {bannerType === 6 && (
          <>
            <div className="form-group col-md-6">
              <InputBox
                label="Code"
                fieldname="text1"
                placeholder="Enter Code"
                value={formData.text1}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group col-md-6">
              <InputBox
                label="Code Text"
                fieldname="text2"
                placeholder="Enter Code Text"
                value={formData.text2}
                onChange={handleInputChange}
              />
            </div>
          </>
        )}

        {bannerType !== 0 && bannerType !== 3 && bannerType !== 4 && (
          <div className="form-group col-md-12">
            <TextAreaBox
              label="Description"
              fieldname="description"
              placeholder="Enter Description"
              value={formData.description}
              onChange={handleInputChange}
            />
          </div>
        )}

        {bannerType === 4 && (
          <>
            <div className="form-group col-md-12">
              <TextAreaBox
                label="Referral Text"
                fieldname="description"
                placeholder="Enter Referral Text"
                value={formData.description}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group col-md-12">
              <TextAreaBox
                label="How It Works"
                fieldname="text3"
                placeholder="Enter How It Works"
                value={formData.text3}
                onChange={handleInputChange}
              />
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <span className="panel-title">{operation} Content</span>
          </div>
          <div className="panel-body">
            <form
              onSubmit={handleSubmit}
              className="stdform"
              encType="multipart/form-data"
            >
              <div className="row">
                {renderTextFields()}
                <div className="form-group col-md-6">
                  <UploadBox
                    label="Upload File"
                    fieldname="banner_upload_file"
                    value=""
                    onChange={handleFileChange}
                  />
                  {filePreview && (
                    <img src={filePreview} alt="File Preview" width="300px" />
                  )}
                </div>

                <div className="form-group col-md-12">
                  <CheckBox
                    label="Set Active"
                    fieldname="isactive"
                    checked={formData.isactive === 1}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        isactive: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                </div>

                <div className="col-md-12">
                  <SubmitButton />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileContentForm;
